import React, { Component } from 'react'

import { Container, Row, Col } from 'reactstrap'
import IssuesList from './IssuesList'
import '../Listing.css'

import withApolloClient from '../../withApolloClient'

import MaintenanceListHeader from "../MaintenanceListHeader"
import RestrictedSection from "../../Components/RestrictedSection"
import { buildPresets } from "../../Filters/presetFilters"

// Car Issues' two default filters, expressed as Advanced Filters presets --
// the same FilterInput shape the query already sends for user filters, so the
// popover, the chips and the query all read one source of truth. Editable:
// users could change the status/stage filters on the legacy bar, so they
// still can.
// "OPEN"/"URGENT" are CarIssues.status's raw TextChoices values (not graphene
// enum names -- status is a plain CharField). 11 is Car.stage's raw
// IntegerChoices value (Car.Status.OUT_OF_SERVICE) -- car_stage is the Task 2
// field that reaches through car, since CarIssues has no stage of its own.
const CAR_ISSUES_PRESETS = buildPresets([
    { fieldName: "status", filterType: "in", filterValues: ["OPEN", "URGENT"], editable: true },
    { fieldName: "car_stage", filterType: "in", filterValues: [11], editable: true },
])

export const CATEGORIES = {
    Mechanical: ["MECHANICAL", "ENGINE", "TIRES", "RADIATOR", "BELT", "WON'T START", "TOTAL LOSS", "BATTERY", "NOISE", "INTAKE", "CROSS MEMBER", "HEADLIGHTS", "BRAKES", "SHUT DOWN", "ACTUATOR", "LEAKING OIL", "CLOCK SPRING", "DOOR LOCK", "DIESEL IN TANK", "AXLE BROKE", "SENSOR", "MUFFLER", "ENGINE MOUNT", "ENGINE LIGHTS", "OVERHEAD", "A/C", "CHECK ENGINE LIGHT", "GAS LEAK", "OBD", "MOBILEYE", "HYBRID", "LOST KEY", "TRANSMISSION", "Won’t Start"],
    Accident: ["BUMPERS", "ACCIDENT", "ACCIDENT + MECHANICAL", "ACCIDENT + TOW", "SUBFRAME", "Touch up", "SMALL SCRATCHES", "GLASS", "INCIDENT"],
    TLC: ["TLC INSPECTION", "LOST PLATE", "INSURANCE/TLC", "TLC"],
    Documents: ["REGISTRATION", "INSURANCE"],
    Alerts: ["OIL CHANGE", "DMV INSPECTION"],
    GPS: ["ITURAN"],
    Other: [],
}

class CarIssueContainer extends Component {
    constructor(props) {
        super(props)
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the declared set and is
        // what Reset returns to.
        this.state = {
            orderBy: ["-id"],
            activeTab: "Issues",
            filterValues: {},
            presets: CAR_ISSUES_PRESETS,
            defaultPresets: CAR_ISSUES_PRESETS,
            selectedDrivers: []
        }
    }

    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };


    render() {
        return (
            <RestrictedSection requiredPermission="view_carissues">
                <Container fluid className="bos-listing-container">
                    <MaintenanceListHeader
                        activeTab={this.state.activeTab}
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        selectedDrivers={this.state.selectedDrivers}
                        presets={this.state.presets}
                        setPresets={this.setPresets}
                        defaultPresets={this.state.defaultPresets}
                        resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                        refetchQuery={() => this.setState({ refetchDrivers: !this.state.refetchDrivers })}
                    />
                    <Row>
                        <Col sm="12">
                            <IssuesList
                                currentUser={this.props.currentUser}
                                selectedDrivers={this.state.selectedDrivers}
                                setSelectedDrivers={(selectedDrivers) => this.setState({ selectedDrivers })}
                                presets={this.state.presets}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}


export default withApolloClient(CarIssueContainer)
